import { render, staticRenderFns } from "./FormattedNoteEditor.vue?vue&type=template&id=53e1dc38&"
import script from "./FormattedNoteEditor.vue?vue&type=script&lang=js&"
export * from "./FormattedNoteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports